import { NavLink } from "react-router-dom";
import { LayoutDashboard, Building2, CalendarDays, CheckSquare, Menu } from "lucide-react";

const ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, key: "dashboard", end: true },
  { to: "/clienti", label: "Clienti", icon: Building2, key: "clienti" },
  { to: "/calendario", label: "Calendario", icon: CalendarDays, key: "calendario" },
  { to: "/task", label: "Task", icon: CheckSquare, key: "task" },
];

const cls = (active) => `flex-1 flex flex-col items-center justify-center gap-0.5 min-h-[56px] text-[11px] font-bold transition-colors ${active ? "text-[#E8173A]" : "text-[#0A1128]"}`;

export const MobileBottomNav = ({ onMenu }) => (
  <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#A6DAFC]/95 backdrop-blur-md border-t border-[#5FB3EA] flex pb-[env(safe-area-inset-bottom)]" data-testid="mobile-bottom-nav">
    {ITEMS.map(({ to, label, icon: Icon, key, end }) => (
      <NavLink key={key} to={to} end={end} className={({ isActive }) => cls(isActive)} data-testid={`bottom-nav-${key}`}>
        <Icon className="h-5 w-5" />{label}
      </NavLink>
    ))}
    <button onClick={onMenu} className={cls(false)} data-testid="bottom-nav-altro"><Menu className="h-5 w-5" />Altro</button>
  </nav>
);
